import React from 'react'
import Col from 'reactstrap/lib/Col'
import Container from 'reactstrap/lib/Container'
import Row from 'reactstrap/lib/Row'
import { bulkRedoRequest, bulkResultsReset } from '../../actions/bulkOperationsActions'
import { BulkRedoBase, BulkRedoResponse, CancelProductionOrdersFailed, RedoProductionOrdersFailed, RedoProductionOrdersSuccess } from '../../api'
import { CommonProps } from '../../models'
import { BulkOperationsViewStore } from '../../reducers/states'
import { isNullOrWhitespace } from '../../utils'
import BulkRedoForm from '../forms/BulkRedoForm'
import { ResetReason } from '../../api'
import BulkProgress from './BulkProgress'
import ExportCSV from '../generic/ExportCSV'
import moment from 'moment'

interface Props extends CommonProps, BulkOperationsViewStore {
  message: string
  productCodes: string
  resetReasons: ResetReason[]
}

class BulkRedoPanel extends React.Component<Props> {
  constructor(props: Props) {
    super(props)
    this.sendBulkRedo = this.sendBulkRedo.bind(this)
  }

  sendBulkRedo(x: BulkRedoBase) {
    const productionOrderIdList = x.productionOrderIds
      .replaceAll('\r\n', ',')
      .replaceAll('\n', ',')
      .replaceAll('\r', ',')
      .replace(/\s/g, '')
      .split(',')
      .filter((x) => !isNullOrWhitespace(x)) //remove blank spaces and generate array

    this.props.dispatch(
      bulkRedoRequest({
        productionOrderIds: productionOrderIdList,
        recalculateCustomerPromiseDate: x.recalculateCustomerPromiseDate,
        reasonPhrase: x.reasonCode,
        reasonCode: x.reasonCode,
        comment: x.message
      })
    )
  }

  renderForm(resetReasons: ResetReason[]) {
    return <BulkRedoForm input=
      {{
        productionOrderIds: '',
        recalculateCustomerPromiseDate: true,
        message: '',
        resetReasons: resetReasons,
        reasonCode: '',
        showCpdConfirmation: false
      }}
      onSubmit={this.sendBulkRedo}></BulkRedoForm>
  }

  toCsvData(data: BulkRedoResponse) {
    return [
      ["orderCode", "productionOrderIds", "errorMessage", "status"],
      ...data.productionOrdersNotFound!.map((item: string) => [null, item, "Not Found", "Not Found"]),
      ...data.productionOrdersRedoFailed!.map((item: RedoProductionOrdersFailed) => [item.orderCode, item.productionOrderIds, item.errorMessage, "Failed"]),
      ...data.productionOrdersCancelFailed!.map((item: CancelProductionOrdersFailed) => [item.orderCode, item.productionOrderIds, "ProductionOrder could not be cancelled", "Not Cancelled"]),
      ...data.productionOrdersRedoSuccess!.map((item: RedoProductionOrdersSuccess) => [item.orderCode, item.productionOrderIds, "", "Success"])
    ];
  }

  renderResponse() {
    var downloadFileName = `productionOrderRedo-${moment().format('YYYY-MM-DD_HH-mm-ss')}.csv`

    return (
      <Container fluid className="p-0">
        <Row>
          <Col md="6">
            <h1>Bulk Redo Result</h1>
          </Col>
          <Col md="6" className="back-button">
            <button onClick={() => this.props.dispatch(bulkResultsReset({}))}> Back </button>
          </Col>
        </Row>
        <div className="response-container">
          {this.props.bulkRedoStatusResponse.result?.productionOrdersRedoSuccess && this.props.bulkRedoStatusResponse.result?.productionOrdersRedoSuccess.length > 0 && (
            <>
              <Row>
                <Col md="12" className='status-success status-heading'>
                  Redone Successfully
                </Col>
              </Row>
              <Row>
                <Col md="2" className="column-highlight">
                  Orders
                </Col>
                <Col md="10" className="column-highlight">
                  Production Order Ids
                </Col>
              </Row>
              {this.props.bulkRedoStatusResponse.result?.productionOrdersRedoSuccess.map((x, index) => (
                <Row key={index}>
                  <Col md="2" className="success-column">
                    {x.orderCode}
                  </Col>
                  <Col md="10" className="success-column">
                    {x.productionOrderIds?.join(', ')}
                  </Col>
                </Row>
              ))}
            </>
          )}
          {this.props.bulkRedoStatusResponse.result?.productionOrdersRedoFailed && this.props.bulkRedoStatusResponse.result?.productionOrdersRedoFailed.length > 0 && (
            <>
              <Row>
                <Col md="12" className='status-error status-heading'>
                  Redo Failed
                </Col>
              </Row>
              <Row>
                <Col md="2" className="column-highlight">
                  Orders
                </Col>
                <Col md="5" className="column-highlight">
                  Production Order Ids
                </Col>
                <Col md="5" className="column-highlight">
                  Error Message
                </Col>
              </Row>
              {this.props.bulkRedoStatusResponse.result?.productionOrdersRedoFailed.map((x, index) => (
                <Row key={index}>
                  <Col md="2" className="failed-column">
                    {x.orderCode}
                  </Col>
                  <Col md="5" className="failed-column">
                    {x.productionOrderIds?.join(', ')}
                  </Col>
                  <Col md="5" className="failed-column">
                    {x.errorMessage}
                  </Col>
                </Row>
              ))}
            </>
          )}
          {this.props.bulkRedoStatusResponse.result?.productionOrdersNotFound && this.props.bulkRedoStatusResponse.result?.productionOrdersNotFound.length > 0 && (
            <>
              <Row>
                <Col md="12" className='status-error status-heading'>
                  Production Orders Not Found
                </Col>
              </Row>
              <Row>
                <Col md="12" className="column-highlight">
                  Production Orders
                </Col>
              </Row>
              {this.props.bulkRedoStatusResponse.result?.productionOrdersNotFound.map((x, index) => (
                <Row key={index}>
                  <Col md="12" className="notfound-column">
                    {x}
                  </Col>
                </Row>
              ))}
            </>
          )}
          <Row>
            <Col md="12" className="export-csv">
              <ExportCSV data={this.toCsvData(this.props.bulkRedoStatusResponse.result!)} fileName={downloadFileName} />
            </Col>
          </Row>
        </div>
      </Container>
    )
  }
  renderProgress() {
    return (
      <BulkProgress itemsProcessed={this.props.bulkRedoStatusResponse.itemsProcessed} totalItems={this.props.bulkRedoStatusResponse.totalItems} remaining={this.props.bulkRedoStatusResponse.remaining} />
    )
  }

  render() {
    if (this.props.bulkRedoStatusResponse.inprogress) {
      return this.renderProgress();
    }
    return this.props.bulkRedoStatusResponse.valid ? this.renderResponse() : this.renderForm(this.props.resetReasons)
  }
}

export default BulkRedoPanel
